import styled from "styled-components";

type ContainerType = {
    background: string;
}

type ColorType = {
    color: string;
}

type BorderType = {
    borderColor: string;
}

export const ContainerMessageData = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
    height: calc(100vh - 40px);
`;

export const Content = styled.div<ContainerType>`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 400px;
    background: ${props => props.background};
    border-radius: 5px;
`;

export const ContentMessageBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  gap: 12px;
`;

export const SectionTitle = styled.div<ColorType>`
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.color};
  letter-spacing: 0.5px;
`;

export const UserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UserItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  border-radius: 8px;
  gap: 12px;
`;

export const UserInfo = styled.div<BorderType>`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 8px;
    border-bottom: 1px solid ${props => props.borderColor};
    padding-bottom: 6px;
`;

export const UserName = styled.div<ColorType>`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.color};
`;

export const UserEmail = styled.div<ColorType>`
  font-size: 12px;
  color: ${props => props.color};
`;

export const ContentSection = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
`;

export const ContentInfo = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
`;



